import { Link } from "@tanstack/react-router";
import { DispatchMark } from "@/components/brand/dispatch-mark";
import { useMeta } from "@/stores/meta";
import { SidebarMenu, SidebarMenuButton, SidebarMenuItem } from "@/components/ui/sidebar";

/** Sidebar header lockup: the deleggate mark + wordmark + running tier.
 * Sits where sidebar-07 puts its team switcher; clicking it goes home. */
export function WorkspaceSwitcher() {
  const meta = useMeta((s) => s.meta);
  const tier = meta ? (meta.cloud ? "Cloud" : meta.devServer ? "Dev server" : meta.env) : "";

  return (
    <SidebarMenu>
      <SidebarMenuItem>
        <SidebarMenuButton asChild size="lg" tooltip="deleggate">
          {/* eslint-disable-next-line @typescript-eslint/no-explicit-any */}
          <Link to={"/" as any}>
            {/* Wrapped so the sidebar's [&>svg]:size-4 rule doesn't shrink the
                mark. currentColor → white in dark, near-black in light. */}
            <span className="flex size-8 shrink-0 items-center justify-center text-foreground">
              <DispatchMark className="h-[26px] w-auto" title="deleggate" />
            </span>
            <div className="grid flex-1 text-left leading-tight">
              <span className="truncate font-display text-[15px] font-semibold tracking-tight">deleggate</span>
              {tier && <span className="truncate text-[11px] capitalize text-muted-foreground">{tier}</span>}
            </div>
          </Link>
        </SidebarMenuButton>
      </SidebarMenuItem>
    </SidebarMenu>
  );
}
